import React from 'react';
import { useNumberInput } from '../lib/useNumberInput';
import HelpTip from './HelpTip';

export default function NumField({
  label, value, onChange, prefix, suffix, hint, help, testId,
}) {
  const { raw, handleChange, handleBlur } = useNumberInput(value, onChange);
  return (
    <label className="block text-sm">
      <span className="text-[#092825] font-medium inline-flex items-center">
        {label}
        {help && <HelpTip text={help} />}
      </span>
      <div className="mt-1 relative">
        {prefix && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">
            {prefix}
          </span>
        )}
        <input
          type="text"
          inputMode="decimal"
          data-testid={testId}
          className={
            'num-input w-full rounded border border-slate-300 focus:border-[#2FA163] focus:ring-1 focus:ring-[#2FA163] outline-none py-2 ' +
            (prefix ? 'pl-7' : 'pl-3') + ' ' +
            (suffix ? 'pr-10' : 'pr-3') + ' text-sm'
          }
          value={raw}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {suffix && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">
            {suffix}
          </span>
        )}
      </div>
      {hint && <span className="text-xs text-slate-500 mt-1 block">{hint}</span>}
    </label>
  );
}
